// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tc-ohlcv .t-vue-ohlcv{opacity:1;color:inherit;font-weight:500}.tc-candle-change{color:#2864F0;margin:0 8px;font-weight:700}.tc-ohlcv button{pointer-events:all;border:0;background:transparent;color:inherit;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
